var TaskProgressUpdater = window.TaskProgressUpdater || {};
(function ($, TaskProgressUpdater) {
    TaskProgressUpdater.init = function (id) {
        if (!$.connection || !$.connection.hub) {
            console.error("SignalR proxy not available. ");
            return;
        }
        MDB.configureSignalR($.connection);
        
        var hub = $.connection.TaskHub;
        var hubClient = hub.client;

        hubClient.rowProcessed = function (recordNumber, totalRows) {
            var progressTracker = $('#import-progress');

            $('#import-progress-imported-records').html(recordNumber);
            $('#import-progress-total-rows').html(totalRows);

            if (progressTracker.hasClass('hidden')) {
                progressTracker.removeClass('hidden');
            }
        };

        hubClient.notify = function (message, type) {
            var notifications = $('#import-progress-notifcations');

            var addNotification = function (m, action) {
                var notification = document.createElement('b');
                notification.innerHTML = message;

                var notificationContainer = document.createElement('div');
                notificationContainer.className = 'col-md-12';
                notificationContainer.innerHTML = notification.outerHTML;

                notifications[action](notificationContainer);
            };

            if (type === 'Success') {
                notifications.prepend(addNotification(message, 'prepend'));
            } else {
                notifications.append(addNotification(message, 'append'));
            }
        };

        connecting = MDB.startSignalR().done(function () {
            var hubServer = hub.server;

            hubServer.subscribeToTaskProgress(id);
            hubServer.getProgress(id);
        });
    }
})(jQuery, TaskProgressUpdater);